import type {
  VoucherConfigResponse,
  VoucherConfigSaveResponse,
  VoucherTypeInput,
} from '@/api/types'
import { apiRequest } from '@/api/client'

export const vouchersApi = {
  get: (restaurantId: number) =>
    apiRequest<VoucherConfigResponse>(`/api/v0/admin/vouchers/${restaurantId}`),
  save: (restaurantId: number, types: Array<VoucherTypeInput>) =>
    apiRequest<VoucherConfigSaveResponse>(
      `/api/v0/admin/vouchers/${restaurantId}`,
      {
        method: 'PUT',
        body: JSON.stringify({ types }),
      },
    ),
}
